import {
  initialState,
  Actions,
  State,
  GET_IN_APP_NOTIFICATIONS,
  GET_IN_APP_NOTIFICATIONS_SUCCESS,
  GET_IN_APP_NOTIFICATIONS_ERROR,
  RESET_IN_APP_NOTIFICATIONS,
} from '../../types/in-app-notification/get-notifications';
import { MARK_NOTIFICATION_READ_SUCCESS } from '../../types/in-app-notification/mark-as-read';
import { MARK_ALL_NOTIFICATIONS_READ_SUCCESS } from '../../types/in-app-notification/mark-all-as-read';
import { InAppNotificationDto } from '../../../types/in-app-notification.dto';

type ExtendedActions = Actions | { type: typeof MARK_NOTIFICATION_READ_SUCCESS; payload: { id: number } } | { type: typeof MARK_ALL_NOTIFICATIONS_READ_SUCCESS; payload: null };

const reducers = (state = initialState, action: ExtendedActions): State => {
  switch (action.type) {
    case GET_IN_APP_NOTIFICATIONS:
      return {
        ...state,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_IN_APP_NOTIFICATIONS_SUCCESS: {
      const existingItems = (action as any).append && state.data ? state.data.data : [];
      const newItems = (action as any).payload.data;

      const mergedMap = new Map<number, InAppNotificationDto>();
      [...existingItems, ...newItems].forEach((n) => mergedMap.set(n.id, n));
      const mergedItems = Array.from(mergedMap.values());

      return {
        ...state,
        data: {
          data: mergedItems,
          pagination: (action as any).payload.pagination,
        },
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    }
    case GET_IN_APP_NOTIFICATIONS_ERROR:
      return {
        ...state,
        states: {
          loading: false,
          error: (action as any).payload,
          success: false,
        },
      };
    case MARK_NOTIFICATION_READ_SUCCESS: {
      if (!state.data) return state;
      const id = (action as any).payload.id;
      return {
        ...state,
        data: {
          ...state.data,
          data: state.data.data.map((n) =>
            n.id === id ? { ...n, read_at: new Date().toISOString() } : n
          ),
        },
      };
    }
    case MARK_ALL_NOTIFICATIONS_READ_SUCCESS: {
      if (!state.data) return state;
      const now = new Date().toISOString();
      return {
        ...state,
        data: {
          ...state.data,
          data: state.data.data.map((n) =>
            n.read_at ? n : { ...n, read_at: now }
          ),
        },
      };
    }
    case RESET_IN_APP_NOTIFICATIONS:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
